var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 23.999061584472656,
    height: 24,
    viewBox: "0 0 23.999061584472656 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_29_08566"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.999061584472656,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_29_08566)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.999530792236328,20C7.581250792236328,20,3.999530792236328,16.418300000000002,3.999530792236328,12C3.999530792236328,7.58172,7.581250792236328,4,11.999530792236328,4C16.41783079223633,4,19.999530792236328,7.58172,19.999530792236328,12C19.999530792236328,16.418300000000002,16.41783079223633,20,11.999530792236328,20ZM11.626200792236329,15.3333L16.339530792236328,10.620000000000001C16.600930792236326,10.360430000000001,16.602430792236326,9.93808,16.342830792236327,9.67667C16.083330792236328,9.41525,15.660930792236329,9.41376,15.399530792236328,9.67333L11.152860792236329,13.92L9.266190792236328,12.04C9.006170792236329,11.78152,8.586220792236329,11.78152,8.326190792236329,12.04C8.063260792236328,12.30079,8.063260792236328,12.72588,8.326190792236329,12.98667L10.666200792236328,15.3333C10.79201079223633,15.4581,10.962330792236328,15.5277,11.139530792236329,15.5267C11.321330792236328,15.5313,11.497130792236328,15.4615,11.626200792236329,15.3333Z",
    fill: "#F7941D",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.a0ec5815ea1db144362120bc05bb689c.svg";
export { ForwardRef as ReactComponent };